import React, {useEffect} from 'react'
import {Link} from 'react-router-dom'
import {app_id} from '../../config'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {ErrorsLayout} from '../ErrorsLayout'
import {useThemeMode} from '../../../../_metronic/partials'

type ErrorFallbackProps = {
  error: Error
  resetErrorBoundary: () => void
}

const BODY_CLASSES = ['bgi-size-cover', 'bgi-position-center', 'bgi-no-repeat']

export const ErrorFallback: React.FC<ErrorFallbackProps> = ({error, resetErrorBoundary}) => {
  const {mode} = useThemeMode()
  BODY_CLASSES.forEach((c) => document.body.classList.add(c))
  document.body.style.backgroundImage =
    mode === 'dark'
      ? `url(${toAbsoluteUrl('/media/auth/bg7-dark.jpg')})`
      : `url(${toAbsoluteUrl('/media/auth/bg7.jpg')})`

  const dashboardUrl = '/analyze/dashboard'

  return (
    <div className='d-flex flex-column flex-root'>
      <div className='d-flex flex-column flex-center flex-column-fluid'>
        <div className='d-flex flex-column flex-center text-center p-10'>
          <div className='card card-flush  w-lg-650px py-5'>
            <div className='card-body py-15 py-lg-20'>
              {/* begin::Title */}
              <h1 className='fw-bolder fs-2qx text-gray-900 mb-4'>System Error</h1>
              {/* end::Title */}

              {/* begin::Text */}
              <div className='fw-semibold fs-6 text-gray-500 mb-2'>
                Something went wrong! Please try again later.
              </div>
              <div className='fw-semibold fs-6 text-gray-500 mb-7'>{error?.message}</div>

              {/* end::Text */}

              {/* begin::Illustration */}
              <div className='mb-11'>
                <img
                  src={toAbsoluteUrl('/media/auth/500-error.png')}
                  className='mw-100 mh-300px theme-light-show'
                  alt=''
                />
                <img
                  src={toAbsoluteUrl('/media/auth/500-error-dark.png')}
                  className='mw-100 mh-300px theme-dark-show'
                  alt=''
                />
              </div>
              {/* end::Illustration */}

              <div className='mb-0'>
                <a href={dashboardUrl} className='btn btn-sm btn-primary'>
                  Return Home
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
